(function () {
    'use strict';

    angular.module('app').factory('HabilFeatures', HabilFeatures);

    HabilFeatures.$inject = [];
    function HabilFeatures() {
        /**
         * Get all installed features
         **/
        const service = {
            IsFvmEditInstalled: isFvmEditInstalled
        };
        return service;

        function isFvmEditInstalled() {
            return true;
        }
    }
})();
